import { queryOptions } from '@tanstack/react-query'

import { sessionGet } from './session.service'

export const sessionKeyFactory = {
  base: () => ['session'],
  get: () => [...sessionKeyFactory.base(), 'get'],
}

export const querySession = () =>
  queryOptions({
    queryKey: sessionKeyFactory.get(),
    queryFn: sessionGet,
  })
